import { render, staticRenderFns } from "./notaTextLayoutDesktop.vue?vue&type=template&id=a427a096&scoped=true&"
import script from "./notaTextLayoutDesktop.vue?vue&type=script&lang=js&"
export * from "./notaTextLayoutDesktop.vue?vue&type=script&lang=js&"
import style0 from "./notaTextLayoutDesktop.vue?vue&type=style&index=0&id=a427a096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a427a096",
  null
  
)

export default component.exports